export class ImportClientsValidatorManager {

    static readonly expectedHeaders = ['Email', 'First Name', 'Last Name'];

    static readonly templateFileName = 'import-clients-template.csv';
    static readonly templateContent = [
        ImportClientsValidatorManager.expectedHeaders.join(','),
        'user1@example.com,UserOne,One',
        'user2@example.com,UserTwo,Two',
        'user3@example.com,UserThree,Three',
        'user4@example.com,UserFour,Four'
    ].join('\r\n');

    private static nameRegex = /^[A-Za-z]+$/;
    private static emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

    static findErrors(csvContent: string): string[] {
        const lines = csvContent
            .replace(/^\uFEFF/, '') // Excel BOM
            .split('\n')
            .map(line => line.replace(/\r$/, ''));

        // header line
        const headers = lines[0].split(',');
        const validHeader = headers.length === this.expectedHeaders.length &&
            headers.every((h, i) => h === this.expectedHeaders[i]); // headers are case sensitive in the backend

        if (!validHeader) {
            return [`Invalid headers. The file must contain only these columns: ${this.expectedHeaders.join(', ')}`];
        }

        const errors: string[] = [];
        let dataRows = 0;

        lines.slice(1).forEach((line, i) => {
            if (/^,*$/.test(line)) return; // ignore blank lines and lines with only commas (e.g. ",," exported by Excel)

            dataRows++;
            const row = i + 2; // +1 header, +1 base 1
            const columns = line.split(',');

            if (columns.length !== this.expectedHeaders.length) {
                errors.push(`Row ${row}: must have exactly ${this.expectedHeaders.length} values (commas are not allowed inside a value)`);
                return;
            }

            const [email, firstName, lastName] = columns;

            if (email.trim() === '') {
                errors.push(`Row ${row}: email is empty`);
            } else if (!this.emailRegex.test(email)) {
                errors.push(`Row ${row}: invalid email "${email}"`);
            }

            this.validateName(firstName, 'first name', row, errors);
            this.validateName(lastName, 'last name', row, errors);
        });

        if (dataRows === 0) {
            return ['The file does not contain any clients to import'];
        }

        return errors;
    }

    private static validateName(value: string, field: string, row: number, errors: string[]) {
        if (value.trim() === '') {
            errors.push(`Row ${row}: ${field} is empty`);
        } else if (!this.nameRegex.test(value)) {
            errors.push(`Row ${row}: ${field} "${value}" must contain only letters`);
        }
    }
}
